import { render, staticRenderFns } from "./ActionsApprove.vue?vue&type=template&id=078751ea"
import script from "./ActionsApprove.vue?vue&type=script&lang=js"
export * from "./ActionsApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports